import React, { FC } from "react";

import { useCartItems } from "store/slices/cart/cart.selectors";
import { CartForm } from "./CartForm";
import { CartItems } from "./CartItems";

import Style from "./Style.module.scss";

const Cart: FC = () => {
  const cartArray = useCartItems();

  if (cartArray.length === 0) {
    return <div className={Style.emptyCart}>سبد خرید شما خالی است.</div>;
  }

  return (
    <div className={Style.cartWrapper}>
      <div className={Style.rightBox}>
        <CartItems items={cartArray} />
      </div>
      <div className={Style.leftBox}>
        <CartForm />
      </div>
    </div>
  );
};

export { Cart };
